/* src/app/views/dashboard/components/app-out-of-date-modal/app-out-of-date-modal.component.scss */
.app-out-of-date-description {
  padding: 2rem 0 1rem;
}
.app-out-of-date-auto-reloading {
  padding-bottom: 1rem;
}
/*# sourceMappingURL=app-out-of-date-modal.component.css.map */
